<template>
  <div class="detail">
    <div class="reject" v-if="(form.status == -1 || form.status == 3) && form.reject_reason && form.reject_reason != ''">
      <van-field
        class="reject-reason"
        v-model="form.reject_reason"
        :readonly="disabled"
        name="name"
        label="作废（退回）原因"
        placeholder="需和银行账户的户名一致"
      />
    </div>
      <van-field
        v-if="form.id && form.id != 0"
        v-model="form.id"
        :disabled="disabled"
        label="申请id"
        placeholder=""
      />
      <van-field name="type" v-model="form.type" label="类型" :disabled="disabled" >
        <template #input>
          <van-radio-group :disabled="disabled" v-model="form.type" direction="horizontal">
            <van-radio name="1">个人</van-radio>
            <van-radio name="2">企业</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.name"
        :disabled="disabled"
        name="name"
        label="姓名（企业）"
        placeholder="需和银行账户的户名一致"
      />
      <van-field
        v-model="form.id_number"
        :disabled="disabled"
        name="id_number"
        label="身份证号（统一社会信用代码）"
        placeholder="身份证号（统一社会信用代码）"
      />
      <van-field
        v-model="form.telephone"
        :disabled="disabled"
        name="telephone"
        label="手机号"
        type="digit"
        placeholder="手机号"
      />
      <van-field
        v-model="form.car_price"
        :disabled="disabled"
        name="car_price"
        label="购车价格（含税）/元"
        type="number"
        placeholder="需与发票上购车金额一致"
      />
      <van-field
        readonly
        :disabled="disabled"
        name="buy_date"
        :value="form.buy_date"
        label="购车日期"
        placeholder="购车日期和开票时间一致"
      />
      <van-field
        v-model="form.bank_name"
        :disabled="disabled"
        name="bank_name"
        label="补贴收款银行开户行"
        placeholder="补贴收款银行开户行"
      />
      <van-field
        v-model="form.bank_card_no"
        name="bank_card_no"
        :disabled="disabled"
        label="补贴收款银行账户号"
        placeholder="补贴收款银行账户号"
      />
      <van-field v-model="form.photo_id_front" name="photo_id_front" label="身份证（统一社会信用代码）照片（正面）" :disabled="disabled" >
        <template #input>
          <div class="upload-icon" >
            <van-image class="upload-icon" :src="form.photo_id_front" @click="preview(form.photo_id_front)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-model="form.photo_id_reverse" name="photo_id_reverse" label="身份证照片（背面）" :disabled="disabled" >
        <template #input>
          <div class="upload-icon">
            <van-image class="upload-icon" :src="form.photo_id_reverse" @click="preview(form.photo_id_reverse)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-model="form.photo_invoice"  name="photo_invoice" label="购车发票照片" :disabled="disabled" >
        <template #input>
          <div class="upload-icon">
            <van-image class="upload-icon" :src="form.photo_invoice" @click="preview(form.photo_invoice)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-if="form.photo_old_for_new"   name="photo_invoice" label="以旧换新相关凭证" :disabled="disabled" >
        <template #input>
          <div class="upload-icon">
            <van-image class="upload-icon" v-for="(photo,i) in form.photo_old_for_new.split(',')" :key="i" :src="photo" @click="preview(photo)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-if="form.photo_commitment"  name="photo_commitment" label="以旧换新承诺书" :disabled="disabled" >
        <template #input>
          <div class="upload-icon">
            <van-image class="upload-icon" :src="form.photo_commitment" @click="preview(form.photo_commitment)">
            </van-image>
          </div>
        </template>
      </van-field>
        <van-field v-model="form.photo_driving_license" name="photo_driving_license" label="车辆行驶证照片" :disabled="disabled" >
          <template #input>
            <div class="upload-icon">
              <van-image class="upload-icon" :src="form.photo_driving_license" @click="preview(form.photo_driving_license)">
              </van-image>
            </div>
          </template>
        </van-field>
        <van-field v-model="form.photo_purchase_tax" name="photo_purchase_tax" label="车辆购置税凭证照片" :disabled="disabled" >
          <template #input>
            <div class="upload-icon">
              <van-image class="upload-icon" :src="form.photo_purchase_tax" @click="preview(form.photo_purchase_tax)">
              </van-image>
            </div>
          </template>
        </van-field> 
  </div>
</template>
<script>
import axios from 'axios'
import { util } from '../../assets/common2.js'
import { ImagePreview } from 'vant'
export default {
  name: 'CarDetail',
  props: {
  },
  data () {
    return {
      form_id: null,
      loading: false,
      form: {},
      disabled: true
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    // CommentComponent
  },
  computed: {
  },
  created: function () {
    this.form_id = this.$route.params.form_id
  },
  mounted: function () {
    this.getDetail()
  },
  methods: {
    preview(img) {
      ImagePreview([img])
    },
    getDetail() {
      util.Arequest((data) => {
        axios.post(`/encrypt3/form/detail?form_id=${this.form_id}&userid=${data.userid}&fid=${this.$store.state.fid}`,{token:data.token}).then(res => {
            if (res.data.msg == 'ok') {
              this.form = res.data.form
              this.loading = false;
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
            } else if (res.data.msg == 'not exists') {
              this.$toast('没有该申请')
            } else if (res.data.msg == 'error merchant') {
              this.$toast('非法请求')
            } else {
              this.$toast('网络繁忙\n稍后重试')
            } 
          }).catch(() => {
            this.$toast('网络繁忙\n稍后重试')
          })
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.reject-reason {
  background-color: aqua;
}
</style>
